export default "__VITE_ASSET__CKFV1Ble__"